module.exports = __webpack_public_path__ + "img/monogram.c25caf32.svg";